import React from 'react';
import StyleBuilder from './StyleBuilder';

function TemplateControls({
  templateName, setTemplateName,
  description, setDescription,
  setThumbnail,
  layout, setLayout,
  btnLoading, handleSubmit,
  availableComponents,
  styleConfig, setStyleConfig
}) {

  // This generic handler is all you need for the dropdowns. It's perfect.
  const handleDropdownChange = (part, value) => {
    setLayout(prev => ({ ...prev, [part]: value }));
  };

  return (
    // We use a div as the main container instead of a form tag.
    // The submit action is handled by the button's onClick.
    <div>
      <div className="accordion" id="templateControlsAccordion">
        
        {/* --- ACCORDION ITEM 1: TEMPLATE DETAILS & LAYOUT --- */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingOne">
            <button className="accordion-button" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne">
              Template Details & Layout
            </button>
          </h2>
          <div id="collapseOne" className="accordion-collapse collapse show" data-bs-parent="#templateControlsAccordion">
            <div className="accordion-body">
              
              {/* Template Details Section */}
              <h5 className="mb-3">Template Details</h5>
              <div className="mb-3">
                <label className="form-label">Template Name</label>
                <input type="text" className="form-control" value={templateName} onChange={e => setTemplateName(e.target.value)} required />
              </div>
              <div className="mb-3">
                <label className="form-label">Description</label>
                <textarea className="form-control" value={description} onChange={e => setDescription(e.target.value)} />
              </div>
              <div className="mb-3">
                <label className="form-label">Thumbnail Image</label>
                <input type="file" className="form-control" onChange={e => setThumbnail(e.target.files[0])} accept="image/*" required />
              </div>

              <hr className="my-4" />

              {/* Layout Builder Section */}
              <h5 className="mb-3">Layout Builder</h5>
              <div className="mb-3">
                <label className="form-label">Top Bar Style</label>
                <select className="form-select" value={layout.topBar} onChange={e => handleDropdownChange('topBar', e.target.value)}>
                  
                  {availableComponents.topBars.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Header Style</label>
                <select className="form-select" value={layout.header} onChange={e => handleDropdownChange('header', e.target.value)}>
                  {availableComponents.headers.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Hero Style</label>
                <select className="form-select" value={layout.hero} onChange={e => handleDropdownChange('hero', e.target.value)}>
                  {availableComponents.heroes.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>

              {/* Page Sections Sub-heading */}
              <h5 className="mb-3 mt-4">Page Sections</h5>
              <div className="mb-3">
                <label className="form-label">Destinations</label>
                <select className="form-select" value={layout.destinations} onChange={e => handleDropdownChange('destinations', e.target.value)}>
                  {availableComponents.destinations.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Packages</label>
                <select className="form-select" value={layout.packages} onChange={e => handleDropdownChange('packages', e.target.value)}>
                  {availableComponents.packages.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">Testimonials Style</label>
                <select className="form-select" value={layout.testimonials} onChange={e => handleDropdownChange('testimonials', e.target.value)}>
                  {availableComponents.testimonials.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
              <div className="mb-3">
                <label className="form-label">About Us Style</label>
                <select className="form-select" value={layout.aboutUs} onChange={e => handleDropdownChange('aboutUs', e.target.value)}>
                  {availableComponents.aboutUs.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>

              <hr className="my-4" />

              <div className="mb-3">
                <label className="form-label">Footer Style</label>
                <select className="form-select" value={layout.footer} onChange={e => handleDropdownChange('footer', e.target.value)}>
                  {availableComponents.footers.map(name => <option key={name} value={name}>{name}</option>)}
                </select>
              </div>
            </div>
          </div>
        </div>

        {/* --- ACCORDION ITEM 2: STYLE BUILDER --- */}
        <div className="accordion-item">
          <h2 className="accordion-header" id="headingTwo">
            <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo">
              Style Builder
            </button>
          </h2>
          <div id="collapseTwo" className="accordion-collapse collapse" data-bs-parent="#templateControlsAccordion">
            <div className="accordion-body">
              {/* The StyleBuilder component goes here */}
              <StyleBuilder styleConfig={styleConfig} setStyleConfig={setStyleConfig} />
            </div>
          </div>
        </div>

      </div>

      {/* --- SAVE BUTTON (Outside the accordion for visibility) --- */}
      <div className="d-grid mt-4">
        <button type="button" className="btn btn-primary btn-lg w-100" disabled={btnLoading} onClick={handleSubmit}>
          {btnLoading ? 'Saving...' : 'Save Template'}
        </button>
      </div>
    </div>
  );
}

export default TemplateControls;